<template>
    <div>
        <container :aside="'police'">
            <div class="warp">
                <!-- <div class="head base-head">
                    <el-row>
                        <el-col :span="24" :offset="0">
                            <el-form label-width="80px" :inline="true" size="mini">
                                <el-form-item label="时间">
                                    <el-date-picker
                                        v-model="dates"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="onsearch">搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </div> -->

                <div class="table-box">
                    <div class="static-head">
                        <el-row >
                            <el-col :span="5" :offset="0">
                                <div class="hit-text">
                                    <span>总数：</span>
                                    <span class="num-text">{{myInfo.total}}</span>
                                    <span>条</span>
                                </div>
                            </el-col>
                            <el-col :span="5" :offset="0">
                                <div class="hit-text">
                                    <span>近三天：</span>
                                    <span class="num-text">{{myInfo.three_day}}</span>
                                    <span>条</span>
                                </div>
                            </el-col>
                            <el-col :span="5" :offset="0">
                                <div class="hit-text">
                                    <span>近一周：</span>
                                    <span class="num-text">{{myInfo.one_week}}</span>
                                    <span>条</span>
                                </div>
                            </el-col>
                            <el-col :span="5" :offset="0">
                                <div class="hit-text">
                                    <span>近一月：</span>
                                    <span class="num-text">{{myInfo.one_month}}</span>
                                    <span>条</span>
                                </div>
                            </el-col>
                            <el-col :span="4" :offset="0">
                                <el-button type="text" size="small" @click="clickcell(myInfo)">查看详情</el-button>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="house-state-box">
                        <el-table id="out-table" :key="symbolKey" :data="tabledata" border stripe size="mini" v-loading="loading" row-key="id" lazy :load="loads" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @cell-click="clickcell">
                            <!-- <el-table-column type="index" label="序号" width="60" align="center"></el-table-column> -->
                            <el-table-column label="辖区" prop="city" show-overflow-tooltip>
                                <template slot-scope="s">
                                    {{s.row[s.row.mode]}}
                                </template>
                            </el-table-column>
                            <el-table-column label="总数" prop="total" show-overflow-tooltip></el-table-column>
                            <el-table-column label="近三天" prop="three_day" show-overflow-tooltip></el-table-column>
                            <el-table-column label="近一周" prop="one_week" show-overflow-tooltip></el-table-column>
                            <el-table-column label="近一月" prop="one_month" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column label="操作" fixed="right" width="240">
                                <template slot-scope="s">
                                    <el-button-group>
                                        <el-button type="primary" size="mini" icon="el-icon-s-home" @click="housedetail(s.row)">查看详情</el-button>
                                    </el-button-group>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </div>
                </div>
                <router-view></router-view>
            </div>
        </container>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            dates: [],
            total: 0,
            queryindex: 0,
            symbolKey: '',
            loading: false,
            tabledata: [],
            pagesize: 15,
            pageNo: 0,
            myInfo: {},
        }
    },
    mounted () {
        this.onsearch();
    },
    methods: {
        onsearch(){
            this.tabledata = [];
            this.gettabledata();
            this.getsameinfo();
        },
        gettabledata(){
            var params = {
                dates: JSON.stringify(this.dates),
            };

            this.$api.getPatrolStatics(params)
            .then(data=>{
                this.symbolKey = Symbol(new Date().toString());

                var item = {};
                for(var i=0; i<data.length;i++){
                    item = data[i];
                    item.id = item.city+item.district+item.police+item.community;
                    if (item.mode!='community') item.hasChildren = true;
                    this.$set(this.tabledata, i, item);
                }
            })
        },
        getsameinfo(){
            this.$api.getPatrolSameStatics('')
            .then(data=>{
                this.myInfo = data;
            })
        },
        loads(tree, treeNode, resolve) {
            var params = {
                mode: tree.mode,
                value: tree[tree.mode],
            }
            this.$api.getPatrolStatics(params)
            .then(data=>{

                var item = {};
                var columns = [];
                for(var i=0; i<data.length;i++){
                    item = data[i];
                    item.id = item.city+item.district+item.police+item.community;
                    if (item.mode!='community') item.hasChildren = true;
                    columns.push(item);
                }
                resolve(columns);

            })
        },
        clickcell(row){
            var item = JSON.stringify(row);

            this.$router.push({path: '/police/patrol/list', query:{item, dates: JSON.stringify(this.dates)}})
        },
    },
}
</script>
<style lang="scss" scoped>
.table-row{
    margin: 2rem 0;
    border-bottom: 1px solid #eee;
}
.static-head{
    padding: 10px;
    margin-bottom: 30px;
    background: #f7f7f7;
    .head-line{
        border-top: 1px solid #eee;
        padding-top: 10px;
    }
    .num-text{
        font-size: 20px;
        color: #333;
        margin-left: 10px;
    }
}
</style>